module.exports = __webpack_public_path__ + "img/dsc_def.18169c4.png";